var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 174,
    viewBox: "0 0 259 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59174 54.1793H256.499C256.524 54.1793 256.55 54.1827 256.562 54.1793C257.442 54.1793 258.156 53.407 258.156 52.4555C258.156 51.99 257.983 51.566 257.706 51.2557L231.999 0.889483C231.718 0.341312 231.183 0 230.603 0H27.4871C26.9072 0 26.3719 0.341312 26.0915 0.889483L0.199316 51.6211C-0.0747091 52.1555 -0.0651502 52.8037 0.22162 53.3312C0.50839 53.8586 1.02776 54.1793 1.59174 54.1793Z",
    fill: "#0F5671"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.562 53.2719H1.5941C0.937557 53.2719 0.347944 53.6735 0.108911 54.2886C-0.130122 54.9005 0.0324195 55.5953 0.516859 56.0415L128.001 172.989C128.307 173.27 128.693 173.41 129.078 173.41C129.464 173.41 129.85 173.27 130.156 172.989L257.64 56.0415C258.124 55.5953 258.287 54.9005 258.048 54.2886C257.812 53.6735 257.216 53.2719 256.562 53.2719Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemIcon);
export default __webpack_public_path__ + "static/media/gem-icon.99fda675fe2d8c63a1f749f04532ab01.svg";
export { ForwardRef as ReactComponent };